import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from '../../../../../../providers/AreasConsumers';
import { getInt } from 'utils/functions';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_DOCUMENT_TYPES } from 'constants/rightsCodes';

import Header from '../../header/Header';
import HeaderLinks from '../../header/HeaderLinks';
import StateTransitionListContainer from './StateTransitionListContainer';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const Route = props => {
  const historyContext = useHistoryWithContext();
  const [documentTypeName, setDocumentTypeName] = useState('');
  const [allowSave, setAllowSave] = useState(false);
  const [onSave, setOnSave] = useState({});
  const [onExport, setOnExport] = useState({ fn2: _fileType => {} });
  const [onImport, setOnImport] = useState({ fn3: _selectedFile => {} });

  const { getElemByAreaKey } = props;

  const documentTypeId = getInt(props.match.params.documentTypeId);

  const onClose = useCallback(() => {
    historyContext.push('/documentTypes');
  }, [historyContext]);

  const onAdd = useCallback(() => {
    historyContext.push(`/documentTypes/${documentTypeId}/stateTransitions/new`);
  }, [documentTypeId, historyContext]);

  const onEdit = useCallback(
    stateTransitionId => () => {
      historyContext.push(`/documentTypes/${documentTypeId}/stateTransitions/${stateTransitionId}`, { documentTypeName: documentTypeName });
    },
    [documentTypeId, documentTypeName, historyContext]
  );

  const onChangedDocumentTypeName = useCallback(name => {
    setDocumentTypeName(name);
  }, []);

  const onSaveFnChanged = useCallback((fn, allowSave) => {
    setOnSave({ fn });
    setAllowSave(allowSave);
  }, []);

  const onExportFnChanged = useCallback(fn2 => {
    setOnExport({ fn2 });
  }, []);

  const onImportFnChanged = useCallback(fn3 => {
    setOnImport({ fn3 });
  }, []);

  return (
    <>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header documentTypeName={documentTypeName} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_DOCUMENT_TYPES} withForbiddenPage={false}>
          <HeaderLinks
            onClose={onClose}
            onSave={onSave.fn}
            onExport={onExport.fn2}
            onImport={onImport.fn3}
            onAdd={onAdd}
            allowSave={allowSave}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_DOCUMENT_TYPES}>
        <StateTransitionListContainer
          documentTypeId={documentTypeId}
          onChangedDocumentTypeName={onChangedDocumentTypeName}
          onSaveFnChanged={onSaveFnChanged}
          onImportFnChanged={onImportFnChanged}
          onExportFnChanged={onExportFnChanged}
          onEdit={onEdit}
        />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired
};

export default withAreaGetter(withRouter(Route));
